import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowDownUpRegular from './arrow-down-up-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowDownUpRegular {...validProps} />;
}
SvgComponent.iconName = 'arrowDownUpRegularIcon';

export const ArrowDownUpRegularIcon = svgIconWrapper(SvgComponent);
